import { useEffect } from "react"

import { useQuery } from "@tanstack/react-query"
import type { AxiosError } from "axios"
import { useRecoilState } from "recoil"

import { USER_KEYS } from "~/api/cache"
import { userService } from "~/api/services/user.service"
import { useDispatchError } from "~/containers/Proposal/state/notifications/QueryErrorModal"
import { currentUserState } from "~/containers/Proposal/state/user/user-state"
import EnvVars from "~/env-vars"
import type { User } from "~/graphql/client"

export const useAuth = (): User => {
  const [currentUser, setCurrentUser] = useRecoilState(currentUserState)
  const onError = useDispatchError()

  const query = useQuery({
    queryKey: USER_KEYS.profile(),
    queryFn: () => userService.getProfile(),
    retry: false,
    staleTime: 1000 * 60 * 60 * 5,
    onError: (error: AxiosError) => {
      console.error({ error })
      if (error.response?.status === 401) {
        console.warn(`Unauthenticated error, redirecting to login`)
        localStorage.setItem(`jwt`, ``)
        window.location.replace(`${EnvVars.API_URL}/auth/sso/login`)
      } else {
        onError(error)
      }
    },
  })

  useEffect(() => {
    if (query.data) setCurrentUser(query.data as User)
  }, [query.data, setCurrentUser])

  return currentUser
}
